import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate } from '@fortawesome/pro-solid-svg-icons/faUserGraduate';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';

const getIconByName = (name) => {
  let icon;
  if (name === 'faUserGraduate') {
    icon = faUserGraduate;
  } else if (name === 'faUsers') {
    icon = faUsers;
  }
  return icon;
};

/**
 * Wrapper component to cleanly put a space after a fontawesome tag.  Because react eats whitespace.
 * Supports both FontAwesome 4 and 5 icons
 *
 * @param icon      a FontAwesome 5 icon
 * @param name      the name of a FontAwesome 4 icon to show.  Ignored if `icon` is specified.
 *
 * @param nbsp      put a space after this icon (equivalent to postNbsp)
 * @param preNbsp   put a space before this icon
 * @param postNbsp  put a space after this icon
 *
 * @param props
 */

class FA extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    icon: PropTypes.object,

    nbsp: PropTypes.bool,
    preNbsp: PropTypes.bool,
    postNbsp: PropTypes.bool,
  };

  render() {
    const {icon, preNbsp, postNbsp, nbsp, ...rest} = this.props;

    return <span>
      {preNbsp && " "}
        {icon ?
          <FontAwesomeIcon icon={icon} {...rest}/> :
          <FontAwesome {...rest}/>
        }
        {(nbsp || postNbsp) && " "}
    </span>;
  }
}

export {
  FA as default,
  getIconByName
};
